import { ErrorMessage, Field, getIn } from "formik"
import { Form } from "react-bootstrap"
import { FormErrorMessage, FormLabel, Required, FormSelectContainer } from "./Components";

export const FormSelect = ({children, name, isRequired, label, formik, noPaste, theme, ...props}) => {
    return (
        <Form.Group className="mb-3">
            <Field name={name}>
            {({ field }) => {
                const error = getIn(formik.errors, field.name);
                const touch = getIn(formik.touched, field.name);
                return (
                    <>
                        {label && <FormLabel>{label} {isRequired && <Required>*</Required>}</FormLabel>}
                        <FormSelectContainer className={(theme?"input-"+theme:"")} 
                            isInvalid={touch && error}
                            {...field} {...props}
                        >
                            {children}
                        </FormSelectContainer>
                        {touch && error && <ErrorMessage name={field.name}>
                            {(msg) => <FormErrorMessage type="invalid">{msg}</FormErrorMessage>}
                        </ErrorMessage>}
                    </>
                )
            }}
            </Field>
        </Form.Group>
        
    )
}